// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ICarrierConfigDto,
  ICarrierDto,
  IClaimActivitiesViewDto,
  IClaimAppealDocumentUploadResponseDto,
  IClaimAppealRequestDto,
  IClaimApprovalStatusCodeDto,
  IClaimAssignRequestDto,
  IClaimEscalationNoteRequestDto,
  IClaimEscalationNoteResponseDto,
  IClaimInfoResponseDto,
  IClaimInternalNoteRequestDto,
  IClaimInternalNoteResponseDto,
  IClaimInternalNoteUpdateDto,
  IClaimSearchDto,
  IClaimStatusTypeDto,
  IClaimTransferCalculationsDto,
  IClaimTransferCreateBatchDto,
  ICreateHsaWithdrawalClaimDto,
  ICustomPageExpenseInfoDto,
  IEmployeeChoiceDto,
  IErrorDto,
  IExpenseStatisticsRequestDto,
  IExpenseStatisticsResponseDto,
  IGenericErrorDto,
  ILetterOfMedicalNecessityCreateDto,
  ILetterOfMedicalNecessityDto,
  ILetterOfMedicalNecessityPatchDto,
  IManualClaimUpdateDto,
  IPageClaimDto,
  IProcessClaimDto,
  IProviderInfoDto,
  IRolloverTransferRequestDto,
  IUpdateProviderDto,
  IWaitingForFundsDto,
} from '../models/index';
import {
    ICarrierConfigDtoFromJSON,
    ICarrierConfigDtoToJSON,
    ICarrierDtoFromJSON,
    ICarrierDtoToJSON,
    IClaimActivitiesViewDtoFromJSON,
    IClaimActivitiesViewDtoToJSON,
    IClaimAppealDocumentUploadResponseDtoFromJSON,
    IClaimAppealDocumentUploadResponseDtoToJSON,
    IClaimAppealRequestDtoFromJSON,
    IClaimAppealRequestDtoToJSON,
    IClaimApprovalStatusCodeDtoFromJSON,
    IClaimApprovalStatusCodeDtoToJSON,
    IClaimAssignRequestDtoFromJSON,
    IClaimAssignRequestDtoToJSON,
    IClaimEscalationNoteRequestDtoFromJSON,
    IClaimEscalationNoteRequestDtoToJSON,
    IClaimEscalationNoteResponseDtoFromJSON,
    IClaimEscalationNoteResponseDtoToJSON,
    IClaimInfoResponseDtoFromJSON,
    IClaimInfoResponseDtoToJSON,
    IClaimInternalNoteRequestDtoFromJSON,
    IClaimInternalNoteRequestDtoToJSON,
    IClaimInternalNoteResponseDtoFromJSON,
    IClaimInternalNoteResponseDtoToJSON,
    IClaimInternalNoteUpdateDtoFromJSON,
    IClaimInternalNoteUpdateDtoToJSON,
    IClaimSearchDtoFromJSON,
    IClaimSearchDtoToJSON,
    IClaimStatusTypeDtoFromJSON,
    IClaimStatusTypeDtoToJSON,
    IClaimTransferCalculationsDtoFromJSON,
    IClaimTransferCalculationsDtoToJSON,
    IClaimTransferCreateBatchDtoFromJSON,
    IClaimTransferCreateBatchDtoToJSON,
    ICreateHsaWithdrawalClaimDtoFromJSON,
    ICreateHsaWithdrawalClaimDtoToJSON,
    ICustomPageExpenseInfoDtoFromJSON,
    ICustomPageExpenseInfoDtoToJSON,
    IEmployeeChoiceDtoFromJSON,
    IEmployeeChoiceDtoToJSON,
    IErrorDtoFromJSON,
    IErrorDtoToJSON,
    IExpenseStatisticsRequestDtoFromJSON,
    IExpenseStatisticsRequestDtoToJSON,
    IExpenseStatisticsResponseDtoFromJSON,
    IExpenseStatisticsResponseDtoToJSON,
    IGenericErrorDtoFromJSON,
    IGenericErrorDtoToJSON,
    ILetterOfMedicalNecessityCreateDtoFromJSON,
    ILetterOfMedicalNecessityCreateDtoToJSON,
    ILetterOfMedicalNecessityDtoFromJSON,
    ILetterOfMedicalNecessityDtoToJSON,
    ILetterOfMedicalNecessityPatchDtoFromJSON,
    ILetterOfMedicalNecessityPatchDtoToJSON,
    IManualClaimUpdateDtoFromJSON,
    IManualClaimUpdateDtoToJSON,
    IPageClaimDtoFromJSON,
    IPageClaimDtoToJSON,
    IProcessClaimDtoFromJSON,
    IProcessClaimDtoToJSON,
    IProviderInfoDtoFromJSON,
    IProviderInfoDtoToJSON,
    IRolloverTransferRequestDtoFromJSON,
    IRolloverTransferRequestDtoToJSON,
    IUpdateProviderDtoFromJSON,
    IUpdateProviderDtoToJSON,
    IWaitingForFundsDtoFromJSON,
    IWaitingForFundsDtoToJSON,
} from '../models/index';

export interface AssignContactToClaimRequest {
    iClaimAssignRequestDto: IClaimAssignRequestDto;
}

export interface ChangeClaimLmnRequest {
    claimId: number;
    lmnId: number;
    updateClaimStatus?: boolean;
}

export interface CreateCarrierRequest {
    iCarrierDto: ICarrierDto;
}

export interface CreateClaimInternalNoteRequest {
    iClaimInternalNoteRequestDto: IClaimInternalNoteRequestDto;
}

export interface CreateHsaWithdrawalClaimRequest {
    iCreateHsaWithdrawalClaimDto: ICreateHsaWithdrawalClaimDto;
}

export interface CreateLmnRequest {
    iLetterOfMedicalNecessityCreateDto: ILetterOfMedicalNecessityCreateDto;
}

export interface DeleteLmnRequest {
    id: number;
}

export interface DisableCarrierConfigRequest {
    id: number;
}

export interface EscalateClaimRequest {
    claimId: number;
    iClaimEscalationNoteRequestDto: IClaimEscalationNoteRequestDto;
}

export interface EscalationNoteUpdateRequest {
    claimId: number;
    iClaimEscalationNoteRequestDto: IClaimEscalationNoteRequestDto;
}

export interface FindCarrierRequest {
    id: number;
}

export interface FindCarrierConfigRequest {
    id: number;
}

export interface GetCarriersRequest {
    searchValue?: string;
}

export interface GetClaimTransfersAmountByClaimIdRequest {
    claimId: number;
}

export interface GetExpenseStatisticsRequest {
    expenseStatisticsRequestDto: IExpenseStatisticsRequestDto;
}

export interface GetLmnRequest {
    id: number;
}

export interface GetProviderByIdRequest {
    id: number;
}

export interface GetTransferAvailableAmountRequest {
    claimId: number;
    accountFromId: number;
}

export interface ManualClaimUpdateRequest {
    claimId: number;
    iManualClaimUpdateDto: IManualClaimUpdateDto;
}

export interface PatchLmnRequest {
    id: number;
    iLetterOfMedicalNecessityPatchDto: ILetterOfMedicalNecessityPatchDto;
}

export interface ProcessClaimRequest {
    claimId: number;
    iProcessClaimDto: IProcessClaimDto;
}

export interface ProcessEmployeeChoiceForClaimRequest {
    claimId: number;
    iEmployeeChoiceDto: IEmployeeChoiceDto;
}

export interface ProcessWaitingForFundsRequest {
    claimId: number;
    iWaitingForFundsDto: IWaitingForFundsDto;
}

export interface SearchClaimsRequest {
    iClaimSearchDto: IClaimSearchDto;
}

export interface SearchForActivitiesViewRequest {
    employeeId?: number;
    claimProcessingStatus?: SearchForActivitiesViewClaimProcessingStatusEnum;
    claimProcessingSubstatus?: SearchForActivitiesViewClaimProcessingSubstatusEnum;
}

export interface SearchProvidersRequest {
    id?: number;
    facilityName?: string;
    firstName?: string;
    lastName?: string;
    taxId?: string;
    cardAcceptorId?: string;
    employeeId?: number;
    carrierId?: number;
    organizationPath?: string;
    organizationId?: number;
    providerIds?: Array<number>;
}

export interface SubmitAppealRequest {
    claimId: number;
    iClaimAppealRequestDto: IClaimAppealRequestDto;
}

export interface SubmitRolloverTransferRequest {
    claimId: number;
    iRolloverTransferRequestDto: IRolloverTransferRequestDto;
}

export interface TransferClaimRequest {
    claimId: number;
    iClaimTransferCreateBatchDto: IClaimTransferCreateBatchDto;
}

export interface UnAssignContactToClaimRequest {
    iClaimAssignRequestDto: IClaimAssignRequestDto;
}

export interface UnlinkClaimLmnRequest {
    claimId: number;
    lmnId: number;
}

export interface UpdateCarrierRequest {
    id: number;
    iCarrierDto: ICarrierDto;
}

export interface UpdateClaimInternalNoteTextRequest {
    claimId: number;
    noteId: number;
    iClaimInternalNoteUpdateDto: IClaimInternalNoteUpdateDto;
}

export interface UpdateProviderRequest {
    id: number;
    iUpdateProviderDto: IUpdateProviderDto;
}

export interface UploadDocumentRequest {
    claimId: number;
    file: Blob;
}

/**
 * ClaimServiceServiceApi - interface
 * 
 * @export
 * @interface ClaimServiceServiceApiInterface
 */
export interface ClaimServiceServiceApiInterface {
    /**
     * 
     * @summary Assign contact to claim
     * @param {IClaimAssignRequestDto} iClaimAssignRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    assignContactToClaimRaw(requestParameters: AssignContactToClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Assign contact to claim
     */
    assignContactToClaim(requestParameters: AssignContactToClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Change claim lmn
     * @param {number} claimId 
     * @param {number} lmnId 
     * @param {boolean} [updateClaimStatus] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    changeClaimLmnRaw(requestParameters: ChangeClaimLmnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimInfoResponseDto>>;

    /**
     * Change claim lmn
     */
    changeClaimLmn(requestParameters: ChangeClaimLmnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimInfoResponseDto>;

    /**
     * 
     * @param {ICarrierDto} iCarrierDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    createCarrierRaw(requestParameters: CreateCarrierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICarrierDto>>;

    /**
     */
    createCarrier(requestParameters: CreateCarrierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICarrierDto>;

    /**
     * 
     * @summary Create claim internal note
     * @param {IClaimInternalNoteRequestDto} iClaimInternalNoteRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    createClaimInternalNoteRaw(requestParameters: CreateClaimInternalNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimInternalNoteResponseDto>>;

    /**
     * Create claim internal note
     */
    createClaimInternalNote(requestParameters: CreateClaimInternalNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimInternalNoteResponseDto>;

    /**
     * 
     * @summary Create HSA withdrawal claim
     * @param {ICreateHsaWithdrawalClaimDto} iCreateHsaWithdrawalClaimDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    createHsaWithdrawalClaimRaw(requestParameters: CreateHsaWithdrawalClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimInfoResponseDto>>;

    /**
     * Create HSA withdrawal claim
     */
    createHsaWithdrawalClaim(requestParameters: CreateHsaWithdrawalClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimInfoResponseDto>;

    /**
     * 
     * @param {ILetterOfMedicalNecessityCreateDto} iLetterOfMedicalNecessityCreateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    createLmnRaw(requestParameters: CreateLmnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ILetterOfMedicalNecessityDto>>;

    /**
     */
    createLmn(requestParameters: CreateLmnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ILetterOfMedicalNecessityDto>;

    /**
     * 
     * @summary Delete letter of medical necessity
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    deleteLmnRaw(requestParameters: DeleteLmnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete letter of medical necessity
     */
    deleteLmn(requestParameters: DeleteLmnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    disableCarrierConfigRaw(requestParameters: DisableCarrierConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICarrierConfigDto>>;

    /**
     */
    disableCarrierConfig(requestParameters: DisableCarrierConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICarrierConfigDto>;

    /**
     * 
     * @summary Escalate claim
     * @param {number} claimId 
     * @param {IClaimEscalationNoteRequestDto} iClaimEscalationNoteRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    escalateClaimRaw(requestParameters: EscalateClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Escalate claim
     */
    escalateClaim(requestParameters: EscalateClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Update escalation note
     * @param {number} claimId 
     * @param {IClaimEscalationNoteRequestDto} iClaimEscalationNoteRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    escalationNoteUpdateRaw(requestParameters: EscalationNoteUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Update escalation note
     */
    escalationNoteUpdate(requestParameters: EscalationNoteUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    findCarrierRaw(requestParameters: FindCarrierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICarrierDto>>;

    /**
     */
    findCarrier(requestParameters: FindCarrierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICarrierDto>;

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    findCarrierConfigRaw(requestParameters: FindCarrierConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICarrierConfigDto>>;

    /**
     */
    findCarrierConfig(requestParameters: FindCarrierConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICarrierConfigDto>;

    /**
     * 
     * @param {string} [searchValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    getCarriersRaw(requestParameters: GetCarriersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICarrierDto>>;

    /**
     */
    getCarriers(requestParameters: GetCarriersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICarrierDto>;

    /**
     * 
     * @summary Get all existing ClaimApprovalStatusCode enums
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    getClaimApprovalStatusCodesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IClaimApprovalStatusCodeDto>>>;

    /**
     * Get all existing ClaimApprovalStatusCode enums
     */
    getClaimApprovalStatusCodes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IClaimApprovalStatusCodeDto>>;

    /**
     * 
     * @summary Get all existing ClaimStatusType enums
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    getClaimStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IClaimStatusTypeDto>>>;

    /**
     * Get all existing ClaimStatusType enums
     */
    getClaimStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IClaimStatusTypeDto>>;

    /**
     * 
     * @summary Get claim transfer amount per account
     * @param {number} claimId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    getClaimTransfersAmountByClaimIdRaw(requestParameters: GetClaimTransfersAmountByClaimIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimTransferCalculationsDto>>;

    /**
     * Get claim transfer amount per account
     */
    getClaimTransfersAmountByClaimId(requestParameters: GetClaimTransfersAmountByClaimIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimTransferCalculationsDto>;

    /**
     * 
     * @param {IExpenseStatisticsRequestDto} expenseStatisticsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    getExpenseStatisticsRaw(requestParameters: GetExpenseStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IExpenseStatisticsResponseDto>>;

    /**
     */
    getExpenseStatistics(requestParameters: GetExpenseStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IExpenseStatisticsResponseDto>;

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    getLmnRaw(requestParameters: GetLmnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ILetterOfMedicalNecessityDto>>;

    /**
     */
    getLmn(requestParameters: GetLmnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ILetterOfMedicalNecessityDto>;

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    getProviderByIdRaw(requestParameters: GetProviderByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IProviderInfoDto>>;

    /**
     */
    getProviderById(requestParameters: GetProviderByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IProviderInfoDto>;

    /**
     * 
     * @summary Getting available transfer amount for claim and account from id
     * @param {number} claimId 
     * @param {number} accountFromId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    getTransferAvailableAmountRaw(requestParameters: GetTransferAvailableAmountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Getting available transfer amount for claim and account from id
     */
    getTransferAvailableAmount(requestParameters: GetTransferAvailableAmountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Manual claim update
     * @param {number} claimId 
     * @param {IManualClaimUpdateDto} iManualClaimUpdateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    manualClaimUpdateRaw(requestParameters: ManualClaimUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimInfoResponseDto>>;

    /**
     * Manual claim update
     */
    manualClaimUpdate(requestParameters: ManualClaimUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimInfoResponseDto>;

    /**
     * 
     * @param {number} id 
     * @param {ILetterOfMedicalNecessityPatchDto} iLetterOfMedicalNecessityPatchDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    patchLmnRaw(requestParameters: PatchLmnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ILetterOfMedicalNecessityDto>>;

    /**
     */
    patchLmn(requestParameters: PatchLmnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ILetterOfMedicalNecessityDto>;

    /**
     * 
     * @summary Process claim
     * @param {number} claimId 
     * @param {IProcessClaimDto} iProcessClaimDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    processClaimRaw(requestParameters: ProcessClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Process claim
     */
    processClaim(requestParameters: ProcessClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Update payment method for claim
     * @param {number} claimId 
     * @param {IEmployeeChoiceDto} iEmployeeChoiceDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    processEmployeeChoiceForClaimRaw(requestParameters: ProcessEmployeeChoiceForClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Update payment method for claim
     */
    processEmployeeChoiceForClaim(requestParameters: ProcessEmployeeChoiceForClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Processing the employee’s choice in waiting for funds flow
     * @param {number} claimId 
     * @param {IWaitingForFundsDto} iWaitingForFundsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    processWaitingForFundsRaw(requestParameters: ProcessWaitingForFundsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Processing the employee’s choice in waiting for funds flow
     */
    processWaitingForFunds(requestParameters: ProcessWaitingForFundsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {IClaimSearchDto} iClaimSearchDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    searchClaimsRaw(requestParameters: SearchClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageClaimDto>>;

    /**
     */
    searchClaims(requestParameters: SearchClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageClaimDto>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    searchExpensesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPageExpenseInfoDto>>;

    /**
     */
    searchExpenses(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPageExpenseInfoDto>;

    /**
     * 
     * @summary Search claims for activity details view
     * @param {number} [employeeId] 
     * @param {'SUBMITTED' | 'PAID' | 'PARTIALLY_PAID' | 'PROCESSING' | 'PARTIALLY_REPAID' | 'REPAID' | 'WAITING_FOR_FUNDS' | 'AUTHORIZED' | 'DECLINED' | 'EXPIRED' | 'REPAYMENT_REQUIRED' | 'DEDUCTIBLE_TRACKING' | 'ACTION_REQUIRED' | 'STOP_PROCESSING' | 'VOIDED' | 'PENDING_ACCOUNT_VERIFICATION' | 'REPAYMENT_INITIATED'} [claimProcessingStatus] 
     * @param {'DOCS_NEEDED' | 'CARRIER_CLAIM' | 'WAITING_FOR_FUNDS' | 'PAYMENT_REJECTED' | 'REPAYMENT_REJECTED' | 'PARTIAL_REPAYMENT' | 'FULL_REPAYMENT' | 'PARTIAL_PAYMENT'} [claimProcessingSubstatus] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    searchForActivitiesViewRaw(requestParameters: SearchForActivitiesViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimActivitiesViewDto>>;

    /**
     * Search claims for activity details view
     */
    searchForActivitiesView(requestParameters: SearchForActivitiesViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimActivitiesViewDto>;

    /**
     * 
     * @param {number} [id] 
     * @param {string} [facilityName] 
     * @param {string} [firstName] 
     * @param {string} [lastName] 
     * @param {string} [taxId] 
     * @param {string} [cardAcceptorId] 
     * @param {number} [employeeId] 
     * @param {number} [carrierId] 
     * @param {string} [organizationPath] 
     * @param {number} [organizationId] 
     * @param {Array<number>} [providerIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    searchProvidersRaw(requestParameters: SearchProvidersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IProviderInfoDto>>>;

    /**
     */
    searchProviders(requestParameters: SearchProvidersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IProviderInfoDto>>;

    /**
     * 
     * @summary Submit claim appeal
     * @param {number} claimId 
     * @param {IClaimAppealRequestDto} iClaimAppealRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    submitAppealRaw(requestParameters: SubmitAppealRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Submit claim appeal
     */
    submitAppeal(requestParameters: SubmitAppealRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Submit rollover transfer for claim
     * @param {number} claimId 
     * @param {IRolloverTransferRequestDto} iRolloverTransferRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    submitRolloverTransferRaw(requestParameters: SubmitRolloverTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Submit rollover transfer for claim
     */
    submitRolloverTransfer(requestParameters: SubmitRolloverTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Transfer claim
     * @param {number} claimId 
     * @param {IClaimTransferCreateBatchDto} iClaimTransferCreateBatchDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    transferClaimRaw(requestParameters: TransferClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Transfer claim
     */
    transferClaim(requestParameters: TransferClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Un assign claim team to claim
     * @param {IClaimAssignRequestDto} iClaimAssignRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    unAssignContactToClaimRaw(requestParameters: UnAssignContactToClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Un assign claim team to claim
     */
    unAssignContactToClaim(requestParameters: UnAssignContactToClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Unlink lmn from claim
     * @param {number} claimId 
     * @param {number} lmnId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    unlinkClaimLmnRaw(requestParameters: UnlinkClaimLmnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Unlink lmn from claim
     */
    unlinkClaimLmn(requestParameters: UnlinkClaimLmnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {number} id 
     * @param {ICarrierDto} iCarrierDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    updateCarrierRaw(requestParameters: UpdateCarrierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICarrierDto>>;

    /**
     */
    updateCarrier(requestParameters: UpdateCarrierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICarrierDto>;

    /**
     * 
     * @summary Change claim internal note text 
     * @param {number} claimId 
     * @param {number} noteId 
     * @param {IClaimInternalNoteUpdateDto} iClaimInternalNoteUpdateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    updateClaimInternalNoteTextRaw(requestParameters: UpdateClaimInternalNoteTextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimInternalNoteResponseDto>>;

    /**
     * Change claim internal note text 
     */
    updateClaimInternalNoteText(requestParameters: UpdateClaimInternalNoteTextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimInternalNoteResponseDto>;

    /**
     * 
     * @param {number} id 
     * @param {IUpdateProviderDto} iUpdateProviderDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    updateProviderRaw(requestParameters: UpdateProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IProviderInfoDto>>;

    /**
     */
    updateProvider(requestParameters: UpdateProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IProviderInfoDto>;

    /**
     * 
     * @summary Upload appeal document
     * @param {number} claimId 
     * @param {Blob} file File to upload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimServiceServiceApiInterface
     */
    uploadDocumentRaw(requestParameters: UploadDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimAppealDocumentUploadResponseDto>>;

    /**
     * Upload appeal document
     */
    uploadDocument(requestParameters: UploadDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimAppealDocumentUploadResponseDto>;

}

/**
 * 
 */
export class ClaimServiceServiceApi extends runtime.BaseAPI implements ClaimServiceServiceApiInterface {

    /**
     * Assign contact to claim
     */
    async assignContactToClaimRaw(requestParameters: AssignContactToClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['iClaimAssignRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iClaimAssignRequestDto',
                'Required parameter "iClaimAssignRequestDto" was null or undefined when calling assignContactToClaim().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims/assign-contact`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IClaimAssignRequestDtoToJSON(requestParameters['iClaimAssignRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Assign contact to claim
     */
    async assignContactToClaim(requestParameters: AssignContactToClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.assignContactToClaimRaw(requestParameters, initOverrides);
    }

    /**
     * Change claim lmn
     */
    async changeClaimLmnRaw(requestParameters: ChangeClaimLmnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimInfoResponseDto>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling changeClaimLmn().'
            );
        }

        if (requestParameters['lmnId'] == null) {
            throw new runtime.RequiredError(
                'lmnId',
                'Required parameter "lmnId" was null or undefined when calling changeClaimLmn().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['updateClaimStatus'] != null) {
            queryParameters['updateClaimStatus'] = requestParameters['updateClaimStatus'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims/{claim-id}/letter-of-medical-necessity/{lmn-id}`;
        urlPath = urlPath.replace(`{${"claim-id"}}`, encodeURIComponent(String(requestParameters['claimId'])));
        urlPath = urlPath.replace(`{${"lmn-id"}}`, encodeURIComponent(String(requestParameters['lmnId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IClaimInfoResponseDtoFromJSON(jsonValue));
    }

    /**
     * Change claim lmn
     */
    async changeClaimLmn(requestParameters: ChangeClaimLmnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimInfoResponseDto> {
        const response = await this.changeClaimLmnRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createCarrierRaw(requestParameters: CreateCarrierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICarrierDto>> {
        if (requestParameters['iCarrierDto'] == null) {
            throw new runtime.RequiredError(
                'iCarrierDto',
                'Required parameter "iCarrierDto" was null or undefined when calling createCarrier().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/carriers`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ICarrierDtoToJSON(requestParameters['iCarrierDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICarrierDtoFromJSON(jsonValue));
    }

    /**
     */
    async createCarrier(requestParameters: CreateCarrierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICarrierDto> {
        const response = await this.createCarrierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create claim internal note
     */
    async createClaimInternalNoteRaw(requestParameters: CreateClaimInternalNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimInternalNoteResponseDto>> {
        if (requestParameters['iClaimInternalNoteRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iClaimInternalNoteRequestDto',
                'Required parameter "iClaimInternalNoteRequestDto" was null or undefined when calling createClaimInternalNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims/internal-notes`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IClaimInternalNoteRequestDtoToJSON(requestParameters['iClaimInternalNoteRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IClaimInternalNoteResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create claim internal note
     */
    async createClaimInternalNote(requestParameters: CreateClaimInternalNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimInternalNoteResponseDto> {
        const response = await this.createClaimInternalNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create HSA withdrawal claim
     */
    async createHsaWithdrawalClaimRaw(requestParameters: CreateHsaWithdrawalClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimInfoResponseDto>> {
        if (requestParameters['iCreateHsaWithdrawalClaimDto'] == null) {
            throw new runtime.RequiredError(
                'iCreateHsaWithdrawalClaimDto',
                'Required parameter "iCreateHsaWithdrawalClaimDto" was null or undefined when calling createHsaWithdrawalClaim().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims/hsa-withdrawals`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ICreateHsaWithdrawalClaimDtoToJSON(requestParameters['iCreateHsaWithdrawalClaimDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IClaimInfoResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create HSA withdrawal claim
     */
    async createHsaWithdrawalClaim(requestParameters: CreateHsaWithdrawalClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimInfoResponseDto> {
        const response = await this.createHsaWithdrawalClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createLmnRaw(requestParameters: CreateLmnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ILetterOfMedicalNecessityDto>> {
        if (requestParameters['iLetterOfMedicalNecessityCreateDto'] == null) {
            throw new runtime.RequiredError(
                'iLetterOfMedicalNecessityCreateDto',
                'Required parameter "iLetterOfMedicalNecessityCreateDto" was null or undefined when calling createLmn().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/letters-of-medical-necessity`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ILetterOfMedicalNecessityCreateDtoToJSON(requestParameters['iLetterOfMedicalNecessityCreateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ILetterOfMedicalNecessityDtoFromJSON(jsonValue));
    }

    /**
     */
    async createLmn(requestParameters: CreateLmnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ILetterOfMedicalNecessityDto> {
        const response = await this.createLmnRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete letter of medical necessity
     */
    async deleteLmnRaw(requestParameters: DeleteLmnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteLmn().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/letters-of-medical-necessity/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete letter of medical necessity
     */
    async deleteLmn(requestParameters: DeleteLmnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteLmnRaw(requestParameters, initOverrides);
    }

    /**
     */
    async disableCarrierConfigRaw(requestParameters: DisableCarrierConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICarrierConfigDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling disableCarrierConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/carrier-configs/disable/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICarrierConfigDtoFromJSON(jsonValue));
    }

    /**
     */
    async disableCarrierConfig(requestParameters: DisableCarrierConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICarrierConfigDto> {
        const response = await this.disableCarrierConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Escalate claim
     */
    async escalateClaimRaw(requestParameters: EscalateClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling escalateClaim().'
            );
        }

        if (requestParameters['iClaimEscalationNoteRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iClaimEscalationNoteRequestDto',
                'Required parameter "iClaimEscalationNoteRequestDto" was null or undefined when calling escalateClaim().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims/claim/{claim-id}/escalate`;
        urlPath = urlPath.replace(`{${"claim-id"}}`, encodeURIComponent(String(requestParameters['claimId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IClaimEscalationNoteRequestDtoToJSON(requestParameters['iClaimEscalationNoteRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Escalate claim
     */
    async escalateClaim(requestParameters: EscalateClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.escalateClaimRaw(requestParameters, initOverrides);
    }

    /**
     * Update escalation note
     */
    async escalationNoteUpdateRaw(requestParameters: EscalationNoteUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling escalationNoteUpdate().'
            );
        }

        if (requestParameters['iClaimEscalationNoteRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iClaimEscalationNoteRequestDto',
                'Required parameter "iClaimEscalationNoteRequestDto" was null or undefined when calling escalationNoteUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims/{claim-id}/escalation-note`;
        urlPath = urlPath.replace(`{${"claim-id"}}`, encodeURIComponent(String(requestParameters['claimId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IClaimEscalationNoteRequestDtoToJSON(requestParameters['iClaimEscalationNoteRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update escalation note
     */
    async escalationNoteUpdate(requestParameters: EscalationNoteUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.escalationNoteUpdateRaw(requestParameters, initOverrides);
    }

    /**
     */
    async findCarrierRaw(requestParameters: FindCarrierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICarrierDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findCarrier().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/carriers/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICarrierDtoFromJSON(jsonValue));
    }

    /**
     */
    async findCarrier(requestParameters: FindCarrierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICarrierDto> {
        const response = await this.findCarrierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async findCarrierConfigRaw(requestParameters: FindCarrierConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICarrierConfigDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findCarrierConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/carrier-configs/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICarrierConfigDtoFromJSON(jsonValue));
    }

    /**
     */
    async findCarrierConfig(requestParameters: FindCarrierConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICarrierConfigDto> {
        const response = await this.findCarrierConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCarriersRaw(requestParameters: GetCarriersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICarrierDto>> {
        const queryParameters: any = {};

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/carriers`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICarrierDtoFromJSON(jsonValue));
    }

    /**
     */
    async getCarriers(requestParameters: GetCarriersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICarrierDto> {
        const response = await this.getCarriersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all existing ClaimApprovalStatusCode enums
     */
    async getClaimApprovalStatusCodesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IClaimApprovalStatusCodeDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/enums/claim-approval-status-code`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IClaimApprovalStatusCodeDtoFromJSON));
    }

    /**
     * Get all existing ClaimApprovalStatusCode enums
     */
    async getClaimApprovalStatusCodes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IClaimApprovalStatusCodeDto>> {
        const response = await this.getClaimApprovalStatusCodesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all existing ClaimStatusType enums
     */
    async getClaimStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IClaimStatusTypeDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/enums/claim-status`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IClaimStatusTypeDtoFromJSON));
    }

    /**
     * Get all existing ClaimStatusType enums
     */
    async getClaimStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IClaimStatusTypeDto>> {
        const response = await this.getClaimStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get claim transfer amount per account
     */
    async getClaimTransfersAmountByClaimIdRaw(requestParameters: GetClaimTransfersAmountByClaimIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimTransferCalculationsDto>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getClaimTransfersAmountByClaimId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims/{claim-id}/transfer/calculate`;
        urlPath = urlPath.replace(`{${"claim-id"}}`, encodeURIComponent(String(requestParameters['claimId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IClaimTransferCalculationsDtoFromJSON(jsonValue));
    }

    /**
     * Get claim transfer amount per account
     */
    async getClaimTransfersAmountByClaimId(requestParameters: GetClaimTransfersAmountByClaimIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimTransferCalculationsDto> {
        const response = await this.getClaimTransfersAmountByClaimIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getExpenseStatisticsRaw(requestParameters: GetExpenseStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IExpenseStatisticsResponseDto>> {
        if (requestParameters['expenseStatisticsRequestDto'] == null) {
            throw new runtime.RequiredError(
                'expenseStatisticsRequestDto',
                'Required parameter "expenseStatisticsRequestDto" was null or undefined when calling getExpenseStatistics().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['expenseStatisticsRequestDto'] != null) {
            queryParameters['expenseStatisticsRequestDto'] = requestParameters['expenseStatisticsRequestDto'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/expenses/statistics`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IExpenseStatisticsResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async getExpenseStatistics(requestParameters: GetExpenseStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IExpenseStatisticsResponseDto> {
        const response = await this.getExpenseStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLmnRaw(requestParameters: GetLmnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ILetterOfMedicalNecessityDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getLmn().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/letters-of-medical-necessity/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ILetterOfMedicalNecessityDtoFromJSON(jsonValue));
    }

    /**
     */
    async getLmn(requestParameters: GetLmnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ILetterOfMedicalNecessityDto> {
        const response = await this.getLmnRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getProviderByIdRaw(requestParameters: GetProviderByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IProviderInfoDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getProviderById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/providers/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IProviderInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async getProviderById(requestParameters: GetProviderByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IProviderInfoDto> {
        const response = await this.getProviderByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Getting available transfer amount for claim and account from id
     */
    async getTransferAvailableAmountRaw(requestParameters: GetTransferAvailableAmountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getTransferAvailableAmount().'
            );
        }

        if (requestParameters['accountFromId'] == null) {
            throw new runtime.RequiredError(
                'accountFromId',
                'Required parameter "accountFromId" was null or undefined when calling getTransferAvailableAmount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims/{claim-id}/transfer-amount-available/{account-from-id}`;
        urlPath = urlPath.replace(`{${"claim-id"}}`, encodeURIComponent(String(requestParameters['claimId'])));
        urlPath = urlPath.replace(`{${"account-from-id"}}`, encodeURIComponent(String(requestParameters['accountFromId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Getting available transfer amount for claim and account from id
     */
    async getTransferAvailableAmount(requestParameters: GetTransferAvailableAmountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getTransferAvailableAmountRaw(requestParameters, initOverrides);
    }

    /**
     * Manual claim update
     */
    async manualClaimUpdateRaw(requestParameters: ManualClaimUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimInfoResponseDto>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling manualClaimUpdate().'
            );
        }

        if (requestParameters['iManualClaimUpdateDto'] == null) {
            throw new runtime.RequiredError(
                'iManualClaimUpdateDto',
                'Required parameter "iManualClaimUpdateDto" was null or undefined when calling manualClaimUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims/{claim-id}`;
        urlPath = urlPath.replace(`{${"claim-id"}}`, encodeURIComponent(String(requestParameters['claimId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: IManualClaimUpdateDtoToJSON(requestParameters['iManualClaimUpdateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IClaimInfoResponseDtoFromJSON(jsonValue));
    }

    /**
     * Manual claim update
     */
    async manualClaimUpdate(requestParameters: ManualClaimUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimInfoResponseDto> {
        const response = await this.manualClaimUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async patchLmnRaw(requestParameters: PatchLmnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ILetterOfMedicalNecessityDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling patchLmn().'
            );
        }

        if (requestParameters['iLetterOfMedicalNecessityPatchDto'] == null) {
            throw new runtime.RequiredError(
                'iLetterOfMedicalNecessityPatchDto',
                'Required parameter "iLetterOfMedicalNecessityPatchDto" was null or undefined when calling patchLmn().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/letters-of-medical-necessity/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ILetterOfMedicalNecessityPatchDtoToJSON(requestParameters['iLetterOfMedicalNecessityPatchDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ILetterOfMedicalNecessityDtoFromJSON(jsonValue));
    }

    /**
     */
    async patchLmn(requestParameters: PatchLmnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ILetterOfMedicalNecessityDto> {
        const response = await this.patchLmnRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Process claim
     */
    async processClaimRaw(requestParameters: ProcessClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling processClaim().'
            );
        }

        if (requestParameters['iProcessClaimDto'] == null) {
            throw new runtime.RequiredError(
                'iProcessClaimDto',
                'Required parameter "iProcessClaimDto" was null or undefined when calling processClaim().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims/{claim-id}/process`;
        urlPath = urlPath.replace(`{${"claim-id"}}`, encodeURIComponent(String(requestParameters['claimId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IProcessClaimDtoToJSON(requestParameters['iProcessClaimDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Process claim
     */
    async processClaim(requestParameters: ProcessClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.processClaimRaw(requestParameters, initOverrides);
    }

    /**
     * Update payment method for claim
     */
    async processEmployeeChoiceForClaimRaw(requestParameters: ProcessEmployeeChoiceForClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling processEmployeeChoiceForClaim().'
            );
        }

        if (requestParameters['iEmployeeChoiceDto'] == null) {
            throw new runtime.RequiredError(
                'iEmployeeChoiceDto',
                'Required parameter "iEmployeeChoiceDto" was null or undefined when calling processEmployeeChoiceForClaim().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims/{claim-id}/employee-process`;
        urlPath = urlPath.replace(`{${"claim-id"}}`, encodeURIComponent(String(requestParameters['claimId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IEmployeeChoiceDtoToJSON(requestParameters['iEmployeeChoiceDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update payment method for claim
     */
    async processEmployeeChoiceForClaim(requestParameters: ProcessEmployeeChoiceForClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.processEmployeeChoiceForClaimRaw(requestParameters, initOverrides);
    }

    /**
     * Processing the employee’s choice in waiting for funds flow
     */
    async processWaitingForFundsRaw(requestParameters: ProcessWaitingForFundsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling processWaitingForFunds().'
            );
        }

        if (requestParameters['iWaitingForFundsDto'] == null) {
            throw new runtime.RequiredError(
                'iWaitingForFundsDto',
                'Required parameter "iWaitingForFundsDto" was null or undefined when calling processWaitingForFunds().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims/{claim-id}/process-waiting-for-funds`;
        urlPath = urlPath.replace(`{${"claim-id"}}`, encodeURIComponent(String(requestParameters['claimId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IWaitingForFundsDtoToJSON(requestParameters['iWaitingForFundsDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Processing the employee’s choice in waiting for funds flow
     */
    async processWaitingForFunds(requestParameters: ProcessWaitingForFundsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.processWaitingForFundsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async searchClaimsRaw(requestParameters: SearchClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageClaimDto>> {
        if (requestParameters['iClaimSearchDto'] == null) {
            throw new runtime.RequiredError(
                'iClaimSearchDto',
                'Required parameter "iClaimSearchDto" was null or undefined when calling searchClaims().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims/search`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IClaimSearchDtoToJSON(requestParameters['iClaimSearchDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPageClaimDtoFromJSON(jsonValue));
    }

    /**
     */
    async searchClaims(requestParameters: SearchClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageClaimDto> {
        const response = await this.searchClaimsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchExpensesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPageExpenseInfoDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/expenses`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICustomPageExpenseInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async searchExpenses(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPageExpenseInfoDto> {
        const response = await this.searchExpensesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Search claims for activity details view
     */
    async searchForActivitiesViewRaw(requestParameters: SearchForActivitiesViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimActivitiesViewDto>> {
        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        if (requestParameters['claimProcessingStatus'] != null) {
            queryParameters['claim_processing_status'] = requestParameters['claimProcessingStatus'];
        }

        if (requestParameters['claimProcessingSubstatus'] != null) {
            queryParameters['claim_processing_substatus'] = requestParameters['claimProcessingSubstatus'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims/search/activities`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IClaimActivitiesViewDtoFromJSON(jsonValue));
    }

    /**
     * Search claims for activity details view
     */
    async searchForActivitiesView(requestParameters: SearchForActivitiesViewRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimActivitiesViewDto> {
        const response = await this.searchForActivitiesViewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchProvidersRaw(requestParameters: SearchProvidersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IProviderInfoDto>>> {
        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['facilityName'] != null) {
            queryParameters['facility_name'] = requestParameters['facilityName'];
        }

        if (requestParameters['firstName'] != null) {
            queryParameters['first_name'] = requestParameters['firstName'];
        }

        if (requestParameters['lastName'] != null) {
            queryParameters['last_name'] = requestParameters['lastName'];
        }

        if (requestParameters['taxId'] != null) {
            queryParameters['tax_id'] = requestParameters['taxId'];
        }

        if (requestParameters['cardAcceptorId'] != null) {
            queryParameters['card_acceptor_id'] = requestParameters['cardAcceptorId'];
        }

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        if (requestParameters['carrierId'] != null) {
            queryParameters['carrier_id'] = requestParameters['carrierId'];
        }

        if (requestParameters['organizationPath'] != null) {
            queryParameters['organization_path'] = requestParameters['organizationPath'];
        }

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        if (requestParameters['providerIds'] != null) {
            queryParameters['provider_ids'] = requestParameters['providerIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/providers`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IProviderInfoDtoFromJSON));
    }

    /**
     */
    async searchProviders(requestParameters: SearchProvidersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IProviderInfoDto>> {
        const response = await this.searchProvidersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Submit claim appeal
     */
    async submitAppealRaw(requestParameters: SubmitAppealRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling submitAppeal().'
            );
        }

        if (requestParameters['iClaimAppealRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iClaimAppealRequestDto',
                'Required parameter "iClaimAppealRequestDto" was null or undefined when calling submitAppeal().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims/{claim-id}/appeal`;
        urlPath = urlPath.replace(`{${"claim-id"}}`, encodeURIComponent(String(requestParameters['claimId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IClaimAppealRequestDtoToJSON(requestParameters['iClaimAppealRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Submit claim appeal
     */
    async submitAppeal(requestParameters: SubmitAppealRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.submitAppealRaw(requestParameters, initOverrides);
    }

    /**
     * Submit rollover transfer for claim
     */
    async submitRolloverTransferRaw(requestParameters: SubmitRolloverTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling submitRolloverTransfer().'
            );
        }

        if (requestParameters['iRolloverTransferRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iRolloverTransferRequestDto',
                'Required parameter "iRolloverTransferRequestDto" was null or undefined when calling submitRolloverTransfer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims/{claim-id}/rollover-transfer`;
        urlPath = urlPath.replace(`{${"claim-id"}}`, encodeURIComponent(String(requestParameters['claimId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IRolloverTransferRequestDtoToJSON(requestParameters['iRolloverTransferRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Submit rollover transfer for claim
     */
    async submitRolloverTransfer(requestParameters: SubmitRolloverTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.submitRolloverTransferRaw(requestParameters, initOverrides);
    }

    /**
     * Transfer claim
     */
    async transferClaimRaw(requestParameters: TransferClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling transferClaim().'
            );
        }

        if (requestParameters['iClaimTransferCreateBatchDto'] == null) {
            throw new runtime.RequiredError(
                'iClaimTransferCreateBatchDto',
                'Required parameter "iClaimTransferCreateBatchDto" was null or undefined when calling transferClaim().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims/{claim-id}/transfer`;
        urlPath = urlPath.replace(`{${"claim-id"}}`, encodeURIComponent(String(requestParameters['claimId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IClaimTransferCreateBatchDtoToJSON(requestParameters['iClaimTransferCreateBatchDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Transfer claim
     */
    async transferClaim(requestParameters: TransferClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.transferClaimRaw(requestParameters, initOverrides);
    }

    /**
     * Un assign claim team to claim
     */
    async unAssignContactToClaimRaw(requestParameters: UnAssignContactToClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['iClaimAssignRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iClaimAssignRequestDto',
                'Required parameter "iClaimAssignRequestDto" was null or undefined when calling unAssignContactToClaim().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims/unassign-contact`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IClaimAssignRequestDtoToJSON(requestParameters['iClaimAssignRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Un assign claim team to claim
     */
    async unAssignContactToClaim(requestParameters: UnAssignContactToClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unAssignContactToClaimRaw(requestParameters, initOverrides);
    }

    /**
     * Unlink lmn from claim
     */
    async unlinkClaimLmnRaw(requestParameters: UnlinkClaimLmnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling unlinkClaimLmn().'
            );
        }

        if (requestParameters['lmnId'] == null) {
            throw new runtime.RequiredError(
                'lmnId',
                'Required parameter "lmnId" was null or undefined when calling unlinkClaimLmn().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims/{claim-id}/letter-of-medical-necessity/{lmn-id}`;
        urlPath = urlPath.replace(`{${"claim-id"}}`, encodeURIComponent(String(requestParameters['claimId'])));
        urlPath = urlPath.replace(`{${"lmn-id"}}`, encodeURIComponent(String(requestParameters['lmnId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Unlink lmn from claim
     */
    async unlinkClaimLmn(requestParameters: UnlinkClaimLmnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unlinkClaimLmnRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateCarrierRaw(requestParameters: UpdateCarrierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICarrierDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateCarrier().'
            );
        }

        if (requestParameters['iCarrierDto'] == null) {
            throw new runtime.RequiredError(
                'iCarrierDto',
                'Required parameter "iCarrierDto" was null or undefined when calling updateCarrier().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/carriers/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ICarrierDtoToJSON(requestParameters['iCarrierDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICarrierDtoFromJSON(jsonValue));
    }

    /**
     */
    async updateCarrier(requestParameters: UpdateCarrierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICarrierDto> {
        const response = await this.updateCarrierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Change claim internal note text 
     */
    async updateClaimInternalNoteTextRaw(requestParameters: UpdateClaimInternalNoteTextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimInternalNoteResponseDto>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling updateClaimInternalNoteText().'
            );
        }

        if (requestParameters['noteId'] == null) {
            throw new runtime.RequiredError(
                'noteId',
                'Required parameter "noteId" was null or undefined when calling updateClaimInternalNoteText().'
            );
        }

        if (requestParameters['iClaimInternalNoteUpdateDto'] == null) {
            throw new runtime.RequiredError(
                'iClaimInternalNoteUpdateDto',
                'Required parameter "iClaimInternalNoteUpdateDto" was null or undefined when calling updateClaimInternalNoteText().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims/{claim-id}/internal-notes/{note-id}`;
        urlPath = urlPath.replace(`{${"claim-id"}}`, encodeURIComponent(String(requestParameters['claimId'])));
        urlPath = urlPath.replace(`{${"note-id"}}`, encodeURIComponent(String(requestParameters['noteId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IClaimInternalNoteUpdateDtoToJSON(requestParameters['iClaimInternalNoteUpdateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IClaimInternalNoteResponseDtoFromJSON(jsonValue));
    }

    /**
     * Change claim internal note text 
     */
    async updateClaimInternalNoteText(requestParameters: UpdateClaimInternalNoteTextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimInternalNoteResponseDto> {
        const response = await this.updateClaimInternalNoteTextRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateProviderRaw(requestParameters: UpdateProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IProviderInfoDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateProvider().'
            );
        }

        if (requestParameters['iUpdateProviderDto'] == null) {
            throw new runtime.RequiredError(
                'iUpdateProviderDto',
                'Required parameter "iUpdateProviderDto" was null or undefined when calling updateProvider().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/providers/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IUpdateProviderDtoToJSON(requestParameters['iUpdateProviderDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IProviderInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async updateProvider(requestParameters: UpdateProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IProviderInfoDto> {
        const response = await this.updateProviderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload appeal document
     */
    async uploadDocumentRaw(requestParameters: UploadDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimAppealDocumentUploadResponseDto>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling uploadDocument().'
            );
        }

        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling uploadDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }


        let urlPath = `/claims/{claim-id}/appeal/document`;
        urlPath = urlPath.replace(`{${"claim-id"}}`, encodeURIComponent(String(requestParameters['claimId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IClaimAppealDocumentUploadResponseDtoFromJSON(jsonValue));
    }

    /**
     * Upload appeal document
     */
    async uploadDocument(requestParameters: UploadDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimAppealDocumentUploadResponseDto> {
        const response = await this.uploadDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
  * @export
  * @enum {string}
  */
export enum SearchForActivitiesViewClaimProcessingStatusEnum {
    SUBMITTED = 'SUBMITTED',
    PAID = 'PAID',
    PARTIALLY_PAID = 'PARTIALLY_PAID',
    PROCESSING = 'PROCESSING',
    PARTIALLY_REPAID = 'PARTIALLY_REPAID',
    REPAID = 'REPAID',
    WAITING_FOR_FUNDS = 'WAITING_FOR_FUNDS',
    AUTHORIZED = 'AUTHORIZED',
    DECLINED = 'DECLINED',
    EXPIRED = 'EXPIRED',
    REPAYMENT_REQUIRED = 'REPAYMENT_REQUIRED',
    DEDUCTIBLE_TRACKING = 'DEDUCTIBLE_TRACKING',
    ACTION_REQUIRED = 'ACTION_REQUIRED',
    STOP_PROCESSING = 'STOP_PROCESSING',
    VOIDED = 'VOIDED',
    PENDING_ACCOUNT_VERIFICATION = 'PENDING_ACCOUNT_VERIFICATION',
    REPAYMENT_INITIATED = 'REPAYMENT_INITIATED'
}
/**
  * @export
  * @enum {string}
  */
export enum SearchForActivitiesViewClaimProcessingSubstatusEnum {
    DOCS_NEEDED = 'DOCS_NEEDED',
    CARRIER_CLAIM = 'CARRIER_CLAIM',
    WAITING_FOR_FUNDS = 'WAITING_FOR_FUNDS',
    PAYMENT_REJECTED = 'PAYMENT_REJECTED',
    REPAYMENT_REJECTED = 'REPAYMENT_REJECTED',
    PARTIAL_REPAYMENT = 'PARTIAL_REPAYMENT',
    FULL_REPAYMENT = 'FULL_REPAYMENT',
    PARTIAL_PAYMENT = 'PARTIAL_PAYMENT'
}
